import { html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { BaseElement } from '../base/base-element.js';

/**
 * Restart button shown in place of play-pause-btn when Practice mode is active.
 * Seeks to 0 and resets the current practice session.
 *
 * @fires restart - dispatched on click
 */
@customElement('restart-button')
export class RestartButton extends BaseElement {
    static styles = [
        BaseElement.styles,
        css`
            :host {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 48px;
                height: 48px;
                border-radius: 50%;
                background-color: #007AFF;
                color: white;
                cursor: pointer;
                transition: background-color 0.15s ease, transform 0.1s ease;
            }

            :host(:hover) {
                background-color: #0066CC;
            }

            :host(:active) {
                transform: scale(0.95);
            }

            :host([disabled]) {
                opacity: 0.5;
                cursor: not-allowed;
                pointer-events: none;
            }

            .icon {
                font-size: 22px;
                line-height: 1;
                user-select: none;
            }
        `,
    ];

    @property({ type: Boolean, reflect: true })
    disabled = false;

    private _onClick(): void {
        if (this.disabled) return;
        this.dispatchEvent(
            new CustomEvent('restart', { bubbles: true, composed: true })
        );
    }

    render() {
        return html`
            <button
                type="button"
                aria-label="Restart practice"
                title="Restart"
                @click=${this._onClick}
            >
                <span class="icon">⟲</span>
            </button>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'restart-button': RestartButton;
    }
}
